import { helper } from "lib/helper";
import { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import img from "../../assets/img/brand/goodybuddy_short.png";
import adminModel from "models/admin.model";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Loader from "components/loader/Loader";
import AddButton from "components/Button/AddButton";
import BackButton from "components/Button/BackButton";

// Dummy user data
// const userData = {
//   _id: "user123",
//   name: "John Doe",
//   mobile: "+1234567890",
//   email: "johndoe@example.com",
//   organization: "Acme Corp",
//   profileImage: img, // Example image URL
//   password: "password123", // For demo purposes, not secure in production
// };

const ProfileUpdatePage = () => {
  const [user, setUser] = useState({});
  const [confirmPassword, setConfirmPassword] = useState(user.password);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  // Toggle password visibility
  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword(!showConfirmPassword);

  // Function to handle form field changes
  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  // Handle confirm password separately
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const getProfileData = async () => {
    setIsLoading(true);
    await adminModel
      .getProfile()
      .then((result) => {
        if (result) {
          setUser({...result?.data?.user , oldPassword : '' , newPassword : '' , confirmPassword : ''});
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        helper.sweetalert.toast(error?.data?.message || "Something went wrong while fetching profile data", "warning");
      });
  };

  // console.log(user);

  // Function to handle profile update
  const handleUpdateProfile = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    console.log(user)
    
     if(user?.newPassword?.toString() !== user?.confirmPassword?.toString()){
      helper.sweetalert.toast('Password and Confirm password doesn\'t match', "warning");
      return;
     }

     if(user?.oldPassword?.toString() !== '' && (user?.newPassword?.toString() === user?.oldPassword?.toString())){
      helper.sweetalert.toast('New password and old password should not be same', "warning");
      return;
      }

      const formData = new FormData();
      formData.append('image' , file);
      formData.append('firstName' , user.firstName)
      formData.append('lastName' , user?.lastName)
      formData.append('email' , user?.email)
      if(user?.newPassword?.toString() !== ''){
        formData.append('password' , user?.newPassword)
      }
      formData.append('mobileNo' , user?.mobileNo)
      formData.append('oldPassword' , user?.oldPassword)
      
      await adminModel
        .profileUpdate(formData)
        .then((res) => {
          if (res) {
            console.log(res);
            helper.sweetalert.toast("Profile updated");
            let userinfo = window.sessionStorage.getItem('userinfo')
            userinfo = JSON.parse(userinfo)
            userinfo = {...userinfo , fullname : res.data.user.firstName + ' ' + res.data.user.lastName , image : res.data.user.profileImage}
            window.sessionStorage.setItem('userinfo' , JSON.stringify(userinfo))
            navigate('/admin/index');
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.clear();
          console.log("data=>", error);
          setIsLoading(false);
          helper.sweetalert.toast(error?.response?.data?.error, "warning");
        });
    
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);

    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setUser((prev) => ({
          ...prev,
          profileImage: event.target.result,
        }));
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  useEffect(() => {
    getProfileData();
  }, []);

  return isLoading ? <Loader/> : (
    <>
      <Container className="pt-7" fluid>
        <Row>
          <div className="col pl-0 pr-0">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Update Profile</h3>
              </CardHeader>
              <CardBody>
                <Form >
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label for="name">First Name</Label>
                        <Input
                          type="text"
                          name="firstName"
                          id="firstName"
                          value={user?.firstName}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label for="name">Last Name</Label>
                        <Input
                          type="text"
                          name="lastName"
                          id="lastName"
                          value={user?.lastName}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label for="email">Email</Label>
                        <Input
                          type="email"
                          name="email"
                          id="email"
                          value={user?.email}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label for="mobile">Mobile Number</Label>
                        <Input
                          type="tel"
                          name="mobileNo"
                          id="mobileNo"
                          value={user?.mobileNo}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label for="password">Previous Password</Label>
                        <InputGroup>
                          <Input
                            type={showPassword ? "text" : "password"}
                            name="oldPassword"
                            id="oldPassword"
                            placeholder="Enter previous password Password"
                            value={user?.oldPassword || ''}
                            onChange={(e) => setUser((prev) => ({...prev , oldPassword : e.target.value}))}
                          />
                          <InputGroupText onClick={togglePasswordVisibility}>
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </InputGroupText>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label for="password">Password</Label>
                        <InputGroup>
                          <Input
                            type={showPassword ? "text" : "password"}
                            name="newPassword"
                            id="newPassword"
                            placeholder="Enter Password"
                            value={user?.newPassword || ''}
                            onChange={(e) => setUser((prev) => ({...prev , newPassword : e.target.value}))}
                          />
                          <InputGroupText onClick={togglePasswordVisibility}>
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </InputGroupText>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    
                  </Row>
                  <Row>
                  <Col md="4">
                      <FormGroup>
                        <Label for="confirmPassword">Confirm Password</Label>
                        <InputGroup>
                          <Input
                            type={showConfirmPassword ? "text" : "password"}
                            name="confirmPassword"
                            id="confirmPassword"
                            placeholder="Enter Confirm Password"
                            value={user?.confirmPassword || ''}
                            onChange={(e) => setUser((prev) => ({...prev , confirmPassword : e.target.value}))}
                          />
                          <InputGroupText onClick={handleConfirmPasswordChange}>
                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                          </InputGroupText>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label for="profileImage">Profile Image</Label>
                        <Input
                          type="file"
                          name="profileImage"
                          id="profileImage"
                          onChange={handleFileChange}
                          // value={user?.profileImage}
                          // onChange={(e) =>
                          //   setUser({
                          //     ...user,
                          //     profileImage: URL.createObjectURL(
                          //       e.target.files[0]
                          //     ),
                          //   })
                          // }
                        />
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      {user?.profileImage && (
                        <img
                          src={`${user?.profileImage}`}
                          alt="Profile Preview"
                          style={{ maxWidth: "100px", maxHeight: "100px" }}
                        />
                      )}
                    </Col>
                  </Row>
                  {/* <div className="d-flex justify-content-end">
                    <AddButton title='Save Changes' onClick={handleUpdateProfile} />
                  </div> */}
                   <div className="d-flex justify-content-between align-items-center">
                      <BackButton />
                      <AddButton title='Save Changes' />
                   </div>
                  {/* <Button color="primary" onClick={handleUpdateProfile}>Update Profile</Button> */}
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ProfileUpdatePage;
